const page = require("../../../../../components/page/page");
const customerProfitDt = require("./customerProfit-dt");

import customerProfitPage from "./customerProfit-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false;

//insert the page  on the body
function HTMLselect(detail) {
  //console.log('customerProfit init>')

  HTMLwasSelected = true;

  //load the page to the index
  const body = document.body;
  body.insertAdjacentHTML("beforeend", customerProfitPage);

  customerProfitDt.start({
    dest: "customerProfit",
    act: "fecthData",
  });
} /*init*/

/****************ELEMENTS*****************/

export function start(detail) {
  //console.log('customerProfit page >', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  show: {
    start: (detail) => {
      page.start(detail);
    },
  },
}; /**/
